import { IonButton } from "@ionic/react";
import { ComponentProps } from "react";
import { FormattedMessage } from "react-intl";

import styles from "@components/buttons/SecondaryButton.module.css";
import SecondaryButtonIcon from "@components/typography/icons/SecondaryButtonIcon";
import SecondaryButtonText from "@components/typography/SecondaryButtonText";
import useKeyboardFocus from "@hooks/useKeyboardFocus";
import { IconName } from "@utils/iconUtils";

type ButtonProps = Pick<
  ComponentProps<typeof IonButton>,
  | "disabled"
  | "expand"
  | "href"
  | "onClick"
  | "onKeyUp"
  | "rel"
  | "routerLink"
  | "tabIndex"
  | "target"
  | "title"
  | "type"
>;

type Props = ButtonProps & {
  icon?: IconName;
  size?: "small" | "medium" | "large";
  textKey?: string;
};

const SecondaryButton = ({ icon, size = "medium", textKey, ...buttonProps }: Props) => {
  const keyboardFocus = useKeyboardFocus();

  const classNames = [styles.button, styles[size]];
  if (keyboardFocus) {
    classNames.push(styles.focus);
  }

  return (
    // eslint-disable-next-line react/forbid-elements
    <IonButton className={classNames.join(" ")} mode="md" {...buttonProps}>
      {textKey && (
        <SecondaryButtonText size={size}>
          <FormattedMessage id={textKey} />
        </SecondaryButtonText>
      )}
      {icon && (
        <span className={textKey ? styles.iconWithText : ""}>
          <SecondaryButtonIcon icon={icon} />
        </span>
      )}
    </IonButton>
  );
};

export default SecondaryButton;
